export default "__VITE_ASSET__ZgrpvA9X__"